var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cta-section" },
    [
      _c(
        "el-row",
        { staticClass: "cta-section-inner" },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c("div", { staticClass: "cta-main" }, [
              _c("h2", { staticClass: "cta-title" }, [
                _vm._v("Collaborate in a Powerful Professional Network")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "cta-description" }, [
                _vm._v(
                  "\n            U-Connect isn’t just a platform; it’s a professional ecosystem where industry experts come together to make deals happen. As a\n            U-Connect member, you’ll have direct access to real estate agents, buyer’s agents, finance experts, accountants, and migration\n            agents who are ready to work together to deliver client satisfaction.\n          "
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cta-main" },
              [
                _c(
                  "el-row",
                  {
                    staticStyle: {
                      "padding-left": "20px",
                      display: "flex",
                      "justify-content": "center"
                    },
                    attrs: { gutter: 20 }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { width: "100%", height: "300px" } },
                      [
                        _c("img", {
                          staticStyle: {
                            width: "100%",
                            height: "100%",
                            "object-fit": "contain"
                          },
                          attrs: {
                            src: require("../../../assets/platformBenefits.png"),
                            alt: "img"
                          }
                        })
                      ]
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "cta-secondary" }, [
              _c("p", { staticClass: "secondary-description" }, [
                _vm._v(
                  "\n            Join U-Connect and experience the benefits of a platform designed to help you grow your business,\n            serve your clients, and access a world of property opportunities.\n            Connect with professionals, close more deals, and elevate your career with U-Connect today.\n          "
                )
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "button-group" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "sign-in-btn",
                      attrs: { type: "primary", size: "large" },
                      on: { click: _vm.redirectToUConnect }
                    },
                    [_vm._v("\n            SIGN IN\n          ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "join-btn",
                      attrs: { type: "primary", size: "large" },
                      on: {
                        click: function($event) {
                          return _vm.joinUConnect()
                        }
                      }
                    },
                    [_vm._v("\n            JOIN U-CONNECT\n          ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11476f22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11476f22","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/uConnectRegistration/uConnectRegistrationSection4.vue
// module id = null
// module chunks = 